import React from 'react'
import { Column, WidgetCell, SegmentedButton } from '@sencha/ext-modern'

import { reconfigButton } from 'tyan/public/utility'
import { getBindedProps } from './utilities'

const renderButtons = ({ _buttons, _tooltip = false, key, title, width, ...columnRest }, that, forViewModel, checkGridData) => {
	const items = _buttons.map((o, i) => {
		const { _button, bind, icon, ui, disabled, hidden, text, handler, ...rest } = reconfigButton(o)
		return {
			text: _tooltip ? '' : _button,
			tooltip: _tooltip ? _button : '',
			...getBindedProps({ _tooltip, bind, icon, ui, disabled, hidden, text, handler }, that, `${key}_${i}`, forViewModel, checkGridData),
			// handler: me => handler && handler(that, me.up('widgetcell').getRecord().data, me.up('widgetcell').getRecord()),
			...rest
		}
	})

	return (<Column key={key} width={width} align='center' text={title} {...columnRest} menuDisabled>
		<WidgetCell height='40px'>
			<SegmentedButton allowToggle={false} defaultUI='' items={items} />
		</WidgetCell>
	</Column>)
}

export default renderButtons